import { AuthStoreState } from 'modules/auth/store/authStore';

export const getIsAnonymous = (authStoreState: AuthStoreState) => {
  return authStoreState.user?.isAnonymous;
};
